import Sprite from '../../Sprite';
import Point from '../../../Utility/Point';
import AnimationComponent from '../../../Component/Animation';

export default class Waves extends Sprite {
    public create(params: any): void {
        super.create({
            name: 'wavesSprite',
            texture: 'WAVE1',
            anchor: new Point(0.5, 0.5),
            alpha: 0.6,
        });
    }

    protected onCreate(params: any): void {
        super.onCreate(params);

        this.addComponent<AnimationComponent>(AnimationComponent, {
            playOnStart: true,
            clipName: 'WavesIdle',
        });
    }
}
